import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { generateText } from "helpers/reviews-helpers";
import SmallBoxedSizesContainer from "./size_filter_children/small_boxed_sizes_container";
import SizeFilterButton from "./size-filter-button";
import SizeFilterActions from "./size-filter-actions";

function SizeFilter({ applySelectedStyles, selectedSizes, sizeNames, sizes }) {
  const [text, setText] = useState("");
  const [isOpen, setOpen] = useState(false);
  const [chosenValue, setChosenValue] = useState([...selectedSizes]);

  const ref = useRef(null);

  useEffect(() => {
    setText(generateText([...selectedSizes], sizeNames));
    setChosenValue([...selectedSizes]);
  }, [selectedSizes]);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && isOpen) {
        setChosenValue([...selectedSizes]);
        setOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, isOpen]);

  const handleFilterClick = () => {
    if (isOpen) {
      setChosenValue([...selectedSizes]);
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const handleApply = () => {
    applySelectedStyles([...chosenValue]);
    setOpen(false);
  };

  const handleClear = () => {
    setChosenValue([]);
    applySelectedStyles([]);
    setOpen(false);
  };

  return (
    <div ref={ref} className="reviews_filters-size_filter">
      <SizeFilterButton text={text} handleClick={handleFilterClick} showLabel={true} />
      {isOpen && (
        <div className="reviews_filters-size_filter-dropdown-small">
          <SmallBoxedSizesContainer
            chosenValue={chosenValue}
            setChosenValue={setChosenValue}
            sizeNames={sizeNames}
            sizes={sizes}
          />
          <SizeFilterActions handleApplyClick={handleApply} handleClearClick={handleClear} />
        </div>
      )}
    </div>
  );
}

SizeFilter.propTypes = {
  applySelectedStyles: PropTypes.func.isRequired,
  selectedSizes: PropTypes.array.isRequired,
  sizeNames: PropTypes.object.isRequired,
  sizes: PropTypes.array.isRequired,
};

export default SizeFilter;
